import { useState, useCallback } from "react";
import { toggleFollowProjectApi } from "../../../api/resources.api";

export const useFollowProject = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const toggleFollowProject = useCallback(async (id: number) => {
    try {
      setLoading(true);
      setError(null);

      const response = await toggleFollowProjectApi(id);

      if (response?.success) {
        return {
          isFollowing: response.is_following,
          message: response.message || "",
        };
      }

      setError(response?.message || "خطا در انجام عملیات");
      return null;
    } catch (err) {
      setError("خطا در ارتباط با سرور");
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    toggleFollowProject,
    loading,
    error,
    reset: () => setError(null),
  };
};
